<template>
  <div class="article-admin">
    <b-form @submit="save">
      <input id="article-id" type="hidden" v-model="article.id" />
      <b-form-group label="Nome:" label-for="article-name">
        <b-form-input id="article-name" type="text" v-model="article.name" required :readonly="mode === 'remove'"
          placeholder="Informe o Nome do Artigo..." />
        <p class="alertInput" v-show="nameLength">
          Nome não pode ultrapassar os 80 caracteres.
        </p>
      </b-form-group>

      <b-form-group label="Descrição:" label-for="article-description">
        <b-form-input id="article-description" type="text" v-model="article.description" required
          :readonly="mode === 'remove'" placeholder="Informe a descrição do Artigo..." />
      </b-form-group>

      <b-form-group v-if="mode === 'save'" label="Categoria:" label-for="article-categoryId">
        <b-form-select id="article-categoryId" :options="categories" v-model="article.categoryId" />
      </b-form-group>
      <b-form-group label="Prioridade ordenação:" label-for="category-sortPriority">
        <b-form-input id="category-sortPriority" type="text" v-model="article.sortPriority" v-mask="'##'" required
          :readonly="mode === 'remove'" />
      </b-form-group>
      <b-form-group label="Status:" label-for="article-status">
        <b-form-select v-if="mode === 'save'" id="article-status" :options="status" v-model="article.status" required />
        <b-form-input v-else id="article-status" type="text" v-model="article.status" readonly />
      </b-form-group>

      <b-form-group v-if="mode === 'save'" label="Conteúdo:" label-for="article-content" style="position: relative">
        <quill-editor v-if="showEditor" v-model="article.content" :options="editorOption">
        </quill-editor>

        <b-button @click="resetContentArticle" :disabled="progressSave" class="btn btn-secondary btn-sm mt-1">
          limpar tudo
        </b-button>
      </b-form-group>

      <b-row>
        <b-col cols="12" class="d-flex justify-content-end">
          <b-button @click="reset" :disabled="progressSave">Novo</b-button>
          <b-button class="ml-2" :disabled="nameLength || progressSave" variant="primary" v-if="mode === 'save'"
            type="submit">Salvar</b-button>
        </b-col>
      </b-row>
    </b-form>
    <hr />
    <div id="table-article" style="height: 400px; overflow: auto; position: relative">
      <table class="table table-hover table-sm small table-borderless">
        <thead>
          <tr>
            <th style="width: 50px" class="th-order text-center">ID</th>
            <th style="width: 150px" class="th-order text-start">Nome</th>
            <th style="width: 200px" class="th-order text-start">Descrição</th>
            <th style="width: 200px" class="th-order text-start">Categoria</th>
            <th style="width: 60px" class="th-order text-center">
              Prioridade ordenação
            </th>
            <th style="width: 80px" class="th-order text-center">Status</th>
            <th style="width: 30px" scope="col" aria-label="btn-actions" />
          </tr>
          <tr class="border-top border-bottom">
            <th style="width: 50px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.id" style="flex-grow: 1; border: 0 none; outline: 0; width: 50px"
                  type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <th style="width: 150px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.name" style="flex-grow: 1; border: 0 none; outline: 0; width: 150px"
                  type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <th style="width: 200px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.description"
                  style="flex-grow: 1; border: 0 none; outline: 0; width: 200px" type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <th style="width: 200px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.category"
                  style="flex-grow: 1; border: 0 none; outline: 0; width: 200px" type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <th style="width: 60px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.sortPriority"
                  style="flex-grow: 1; border: 0 none; outline: 0; width: 80px" type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <th style="width: 80px">
              <div class="d-flex align-items-center border p-1">
                <i class="fa fa-search" />
                <b-form-input v-model="params.status" style="flex-grow: 1; border: 0 none; outline: 0; width: 80px"
                  type="text" class="
                    search-input
                    ng-pristine ng-valid ng-touched
                    border-none
                    shadow-none
                  " autoComplete="off" />
              </div>
            </th>
            <td style="width: 30px" class="search-group ng-star-inserted d-print-none" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="article in articles" :class="article.status === 'INATIVO'
              ? 'table-secondary text-secondary'
              : ''
            " :key="article.id">
            <th style="width: 50px" class="th-order text-center">
              {{ article.id }}
            </th>
            <th style="width: 150px" class="th-order text-start">
              {{ article.name }}
            </th>
            <th style="width: 200px" class="th-order text-start">
              {{ article.description }}
            </th>
            <th style="width: 200px" class="th-order text-start">
              {{ article.category }}
            </th>
            <th style="width: 200px" class="th-order text-center">
              {{ article.sortPriority }}
            </th>
            <th style="width: 80px" class="th-order text-center">
              {{ article.status }}
            </th>
            <th style="width: 30px" class="th-order text-center">
              <div style="cursor: pointer" @click="loadArticle(article)" class="mr-2">
                <svg style="font-size: 1.3rem" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="edit"
                  class="svg-inline--fa fa-edit fa-w-18 text-success" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512">
                  <path fill="currentColor"
                    d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z">
                  </path>
                </svg>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div v-show="progress" class="text-center">
        <p>Carregando...</p>
        <b-spinner variant="dark" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import TableSearch from "../TableSearch.vue";
import hljs from "highlight.js";
import "highlight.js/styles/monokai-sublime.css";

const maxRows = 10;
const maxCols = 5;
const tableOptions = [];
for (let r = 1; r <= maxRows; r++) {
  for (let c = 1; c <= maxCols; c++) {
    tableOptions.push("newtable_" + r + "_" + c);
  }
}

export default {
  name: "ArticleAdmin",
  components: { TableSearch },
  data: function () {
    return {
      progressSave: false,
      showEditor: true,
      contentAux: "",
      mode: "save",
      article: {},
      params: {},
      articles: [],
      lastSearch: {},
      progress: true,
      categories: [],
      page: 0,
      status: ["ATIVO", "INATIVO"],
      editorOption: {
        debug: "debug",
        theme: "snow",
        modules: {
          imageDrop: true,
          table: true,
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ font: [] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["clean"],
              ["link", "image", "video"],
              [
                { table: tableOptions },
                { table: "append-row" },
                { table: "append-col" },
              ],
            ],
          },
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
    };
  },
  watch: {
    params: {
      handler() {
        this.loadArticles(true, this.params);
      },
      deep: true,
    },
  },
  computed: {
    nameLength() {
      return `${this.article.name}`.length > 80 ? true : false;
    },
  },
  methods: {
    loadArticles(isFistPage, params) {
      this.progress = true;
      const url = `${baseApiUrl}/api/artigos`;
      if (isFistPage) {
        this.page = 0;
        this.articles = [];
      }
      axios
        .get(url, {
          params: {
            ...params,
            size: 20,
          },
        })
        .then((res) => {
          this.progress = false;
          if (isFistPage) {
            this.articles = [];
            this.lastSearch = {};
          }
          this.articles.push(...res.data.content);
          this.lastSearch = { ...res.data };
          this.page++;
          this.isFistPage = false;
        });
    },
    setParams() {
      this.params = {
        id: this.idSearch,
        name: this.nameSearch,
        description: this.descriptionSearch,
        category: this.category,
        status: this.statusSearch,
      };
    },
    reset() {
      this.mode = "save";
      this.article = {};
      this.loadArticles(true, this.params);
    },
    resetContentArticle() {
      this.article.content = "";
    },
    save(event) {
      event.preventDefault();
      if (this.article.content === undefined || this.article.content === "") {
        showError("Conteúdo do artigo é obrigatório");
        return;
      }
      this.progressSave = true;
      const method = this.article.id ? "put" : "post";
      const id = this.article.id ? `/${this.article.id}` : "";
      const article = {
        name: this.article.name,
        description: this.article.description,
        categoryId: this.article.categoryId,
        sortPriority: Number(this.article.sortPriority),
        status: this.article.status,
        content: this.article.content,
      };
      axios[method](`${baseApiUrl}/api/artigos${id}`, article)
        .then((res) => {
          if (res !== undefined) {
            this.$toasted.global.defaultSuccess();
            this.reset();
            this.progressSave = false;
          }
          this.progressSave = false;
        })
        .catch((error) => {
          this.progressSave = false;
          showError(error);
          if (error.response.data.fields !== undefined) {
            error.response.data.fields.forEach((element) => {
              showError(element.userMessage);
            });
          }
        });
    },
    loadArticle(article, mode = "save") {
      this.mode = mode;
      axios
        .get(`${baseApiUrl}/api/publico/artigos/${article.id}`)
        .then((res) => (this.article = res.data));
    },
    loadCategories() {
      const url = `${baseApiUrl}/api/categorias`;
      axios.get(url).then((res) => {
        this.categories = res.data
          .map((category) => {
            return { value: category.id, text: category.path };
          })
          .sort((a, b) => a.text.localeCompare(b.text));
      });
    },
  },
  mounted() {
    this.loadCategories();
    this.loadArticles(true);
    const listElm = document.querySelector("#table-article");
    listElm.addEventListener("scroll", () => {
      if (
        listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight &&
        !this.lastSearch.empty
      ) {
        this.loadArticles(false, {
          ...this.params,
          page: (this.lastSearch.number += 1),
        });
      }
    });
  },
};
</script>
<style>
.alertInput {
  margin-top: 5px;
  font-size: 70%;
  color: red;
}

.search-input {
  height: 20px;
  font-size: 0.8rem;
}

.ql-container {
  min-height: 200px;
}
</style>